import { motion, useReducedMotion } from "framer-motion";
import { useLocation } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";

const WHATSAPP_NUMBER = "916263206697";
const PREFILL_TEXT = "M Web Visitor : looking for support";
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  PREFILL_TEXT
)}`;

// Pages with their own fixed bottom bar - lift the button clear of it so it
// never covers the bar's primary action.
const LIFTED_PATHS = ["/start"];

export default function WhatsAppButton() {
  const reduceMotion = useReducedMotion();
  const { pathname } = useLocation();
  const lifted = LIFTED_PATHS.includes(pathname);

  return (
    <motion.a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      title="Chat with us on WhatsApp"
      data-testid="whatsapp-float-button"
      className="fixed right-4 z-50 grid h-12 w-12 place-items-center rounded-full bg-[#25D366] shadow-[0_6px_18px_rgba(37,211,102,0.4)] sm:right-5 sm:h-14 sm:w-14"
      style={{
        bottom: lifted
          ? "calc(5.5rem + env(safe-area-inset-bottom))"
          : "calc(1rem + env(safe-area-inset-bottom))",
      }}
      initial={{ opacity: 0, scale: 0.4, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.4 }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.95 }}
    >
      {/* A few pulses to draw the eye on arrival, then it stays still so it
          doesn't keep washing over the content underneath. */}
      {!reduceMotion && (
        <motion.span
          className="absolute inset-0 rounded-full bg-[#25D366]"
          initial={{ opacity: 0.5, scale: 1 }}
          animate={{ opacity: 0, scale: 1.6 }}
          transition={{ duration: 1.8, repeat: 3, ease: "easeOut", delay: 1 }}
        />
      )}
      <FaWhatsapp className="relative h-6 w-6 text-white sm:h-7 sm:w-7" />
    </motion.a>
  );
}
